export default __webpack_public_path__ + "static/img3-cd50892631d9feec09afa140a1ebbd20.jpg";